import { useEffect, useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { Card } from "primereact/card";

import { GenericSettings, SmtpSettings } from "../systemSettings/SystemSettings";
import { clearCache, fetchSystemSettings } from "../systemSettings/systemSettingsApi";
import GenericSettingsForm from "./GenericSettingsForm";
import SmtpSettingsForm from "./SmtpSettingsForm";

export default function SystemSettingsPage() {
  const [smtpSettings, setSmtpSettings] = useState<SmtpSettings>();
  const [genericSettings, setGenericSettings] = useState<GenericSettings>();

  useEffect(() => {
    doFetchSystemSettings();
  }, []);

  const doFetchSystemSettings = async () => {
    const { smtpSettings, genericSettings } = await fetchSystemSettings();
    setSmtpSettings(smtpSettings);
    setGenericSettings(genericSettings);
  };

  const onClearCache = async () => {
    await clearCache();
  };

  return (
    <Card title="Setari sistem">
      <TabView className="-mt-4">
        <TabPanel header="Generic">
          <div className="flex align-items-center justify-content-between">
            <span className="text-lg font-medium">Curatare cache</span>
            <Button label="Clear" icon="pi pi-eraser" outlined onClick={onClearCache} />
          </div>
          <Divider className="my-4" />
          {genericSettings && <GenericSettingsForm genericSettings={genericSettings} />}
        </TabPanel>
        <TabPanel header="SMTP">{smtpSettings && <SmtpSettingsForm systemSettings={smtpSettings} />}</TabPanel>
      </TabView>
    </Card>
  );
}
